export default __webpack_public_path__ + "static/media/vincent-versluis.93f015e5.jpg";